import { render, staticRenderFns } from "./camsLogin.vue?vue&type=template&id=cc188fb8"
import script from "./camsLogin.vue?vue&type=script&lang=js"
export * from "./camsLogin.vue?vue&type=script&lang=js"
import style0 from "./camsLogin.vue?vue&type=style&index=0&id=cc188fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports